var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0.75C12.5039 0.75 0.75 12.5039 0.75 27C0.75 41.4961 12.5039 53.25 27 53.25C41.4961 53.25 53.25 41.4961 53.25 27C53.25 12.5039 41.4961 0.75 27 0.75ZM35.4434 27.4043L22.6465 36.7148C22.5763 36.7653 22.4936 36.7954 22.4075 36.8018C22.3213 36.8083 22.2351 36.7909 22.1582 36.7515C22.0813 36.7122 22.0167 36.6524 21.9716 36.5787C21.9264 36.5051 21.9025 36.4204 21.9023 36.334V17.7246C21.9021 17.638 21.9258 17.5531 21.9708 17.4792C22.0158 17.4052 22.0805 17.3452 22.1575 17.3058C22.2346 17.2664 22.3211 17.249 22.4074 17.2557C22.4937 17.2624 22.5764 17.2929 22.6465 17.3438L35.4434 26.6484C35.5038 26.6912 35.5531 26.7478 35.5872 26.8136C35.6212 26.8794 35.639 26.9523 35.639 27.0264C35.639 27.1004 35.6212 27.1734 35.5872 27.2391C35.5531 27.3049 35.5038 27.3615 35.4434 27.4043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.011139e92aed537f4df182c53fdaa738.svg";
export { ForwardRef as ReactComponent };